'use client';
import { Link } from "@/i18n/routing";
import { HouseIcon, HousePlug, RefreshCcw, Smile } from "lucide-react";
import React, { ReactNode } from "react";
import { Button } from "../ui/button";

interface ErrorBoundaryProps {
    children: ReactNode;
    errorComponent?: ReactNode | null;
    place?: string;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };

    }

    static getDerivedStateFromError(_: Error): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {

        const { message,
            name,
            stack } = error
        const userAgent = navigator.userAgent;
        const platform = navigator.platform;
        const language = navigator.language;
        const currentUrl = window.location.href;
        const addInfo = { userAgent, platform, language, currentUrl }
        const place = `Place: ${JSON.stringify(this.props?.place)}`
        const sendmsg = `DED<b>${message}</b>\n\n\n  <b>${name}</b>\n\n\n <b>${stack}</b> \n\n\n <b>${JSON.stringify(addInfo)}</b>\n\n\n<b>⚠️${place}⚠️</b>`
        const encodedMsg = encodeURIComponent(sendmsg);
        try {
            fetch(`https://api.telegram.org/bot7506786216:AAE30KEWCELe7rdm48dPOkUyXbd182-_Jvw/sendMessage?chat_id=-4652360322&parse_mode=html&text=${encodedMsg}`).then(res => console.log(res)).catch(error => console.error('Error:', error));
        }
        catch {

        } finally {
            console.log("REQUESTED")
        }

    }

    render() {
        if (this.state.hasError) {
            return this.props?.errorComponent
                ? this.props.errorComponent
                : <div>
                    <div className="flex flex-col items-center py-2 bg-white text-black ">
                        <p className="text-xl"> The service is undergoing some work. Don't worry, everything is fine. Try again later</p> <Smile /></div>
                    <div className="flex justify-center gap-4 mt-6 items-center ">
                        <Button><Link className="flex items-center gap-4   font-bold" href={"/"}>
                            <HouseIcon /> GO HOME
                        </Link></Button>
                        <Button onClick={() => {
                            window.location.reload()
                        }}>Refresh <RefreshCcw /></Button>
                    </div>
                </div>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;